module.exports = __webpack_public_path__ + "img/humidity.0d5fcc11.svg";